import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import Api from "../Services/Api";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const clickLogin = async (e) => {
    e.preventDefault();

    const email = e.target.email.value;
    const senha = e.target.password.value;

    try {
      const response = await Api.post("/auth/login", {
        email,
        password: senha,
      });

      if (response.data.ok) {
        console.log("logou");
        // salva o usuário no contexto
        login(response.data.user);

        // 🔥 REDIRECIONAMENTO AQUI
        navigate(response.data.redirect);
      }
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Falha no login");
    }
  };


  return (
    <div className="page">
      <div className="grid-overlay" aria-hidden="true" />
      <div className="light-glow" aria-hidden="true" />

      <div className="login-card">
        <div className="card-header">
          <img src="/logo-horizontal.png" alt="Logo Smart Olfativos" />
          <h1>Smart Finance</h1>
        </div>

        <form className="login-form" onSubmit={clickLogin}>
          <label htmlFor="email">E-mail</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="seunome@email.com"
            required
          />

          <label htmlFor="password">Senha</label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Sua senha"
            required
          />

          <button type="submit">Entrar</button>
        </form>

        <div className="card-actions">
          <a className="link" href="#recuperar">
            Esqueci minha senha
          </a>
          <span className="support">Primeiro acesso? Fale com o suporte</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
